import Utility from '@/utils/Utility'

export default {
  name: 'TypePdf',
  props: {
    model: {
      type: Object,
      required: true,
    }
  },
  mounted () {

  },
  computed: {
    showPdf() {
      return this.model.attachments &&
        this.model.attachments.length
    },
    pdf() {
      return this.model.attachments
    }
  },
}
